<div class="comm-tools">
    <a class="btn qa-deskit-btn" *ngIf="showDeskitLink" href="#" title="{{'deskitDealTitle' | translate}}" (click)="pushToDeskit()">
        <img [src]="deskitImagePath" class="svg-icon" />
        <div class="caption">
            <span translate="deskitDeal"></span>
        </div>
    </a>
</div>
